import App from './App.svelte';

import '../public/main.css'

const app = new App({
	target: document.body,
	props: {
		matrix: {
			crown: {
				src: 'assets/logos/crown/RECO_emblem.png',
				link: '/',
			},
			navs: [
				{
					id: 'Projects',
					link: '#projects'
				},
				{
					id: 'Consultation',
						link: '#consultation'
				},
				{
					id: 'Services',
					link: '#services'
				},
				{
					id: 'Technology',
					link: '#tech'
				},
				{
					id: 'About Us',
					link: '#about-us'
				},
				{
					id: 'Contact Us',
					link: '#contact-us'
				}
			],
			connect: {
				meta: 'Contact Us',
				title: 'Thank you for your interest in R-ECO',
				content: {
					lead: "Feel free to reach out and open up a conversation using the phone number below, the adjacent webform, or via our chatbot.",
					contact: [
						{
							key: "Phone",
							value: "01865 595 264",
							icon: `
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
								</svg>
							`
						},
						{
							key: "Address",
							value: "8 Benson Place, Oxford, OX2 6QH",
							icon: `
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
								</svg>
							`
						}
					],
					legal: {
						name: "The Renewable Energy Co-operative Ltd",
						vat: "992 4156 93",
						coop: "The Renewable Energy Co-operative Limited. is a Co-operative Society registered by the Financial Conduct Authority.",
						coopReg: "4004"
					}
				}
			}
		},
		eidos: {
			feature: {
				title: "Embrace the power of nature",
				text: "And together, we'll determine a green energy solution that's right for you",
				img: {
					src: 'assets/modified/feature.jpg',
					alt: 'Solar PV Domestic Installation'
				}
			},
			envision: {
				meta: 'Projects',
				title: 'Making our planet more sustainable',
				text: "Over 15 years we've completed hundreds of installations and delivered bespoke energy systems of the highest standard",
				projects: [
					{
						id: 1,
						src: "assets/modified/envision/cmpz/small/1-small.jpg",
						alt: ""
					},
					{
						id: 2,
						src: "assets/modified/envision/cmpz/small/2-small.jpg",
						alt: ""
					},
					{
						id: 3,
						src: "assets/modified/envision/cmpz/small/3-small.jpg",
						alt: ""
					},
					{
						id: 4,
						src: "assets/modified/envision/cmpz/small/4-small.jpg",
						alt: ""
					},
					{
						id: 6,
						src: "assets/modified/envision/cmpz/small/6-small.jpg",
						alt: ""
					},
					{
						id: 9,
						src: "assets/modified/envision/cmpz/small/9-small.jpg",
						alt: ""
					},
					{
						id: 11,
						src: "assets/modified/envision/cmpz/small/11-small.jpg",
						alt: ""
					},
					{
						id: 12,
						src: "assets/modified/envision/cmpz/small/12-small.jpg",
						alt: ""
					},
					{
						id: 13,
						src: "assets/modified/envision/cmpz/small/13-small.jpg",
						alt: ""
					},
					{
						id: 16,
						src: "assets/modified/envision/cmpz/small/16-small.jpg",
						alt: ""
					},
					{
						id: 17,
						src: "assets/modified/envision/cmpz/small/17-small.jpg",
						alt: ""
					},
					{
						id: 18,
						src: "assets/modified/envision/cmpz/small/18-small.jpg",
						alt: ""
					}
				]
			},
			pitch: {
				meta: 'Free Consultation',
				title: "Renewable energy could be the next step on your path to a sustainable future",
				text: "We know upgrading to a renewable energy system is a big decision, and that's why we offer a free, no-strings-attached consultation",
				items: [
					{
						icon: `
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
						</svg>
						`,
						id: 'Informal Discussions',
						text: 'Determine your current energy usage and forecast your future requirements',
					},
					{
						icon: `
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
						</svg>
						`,
						id: 'A Technical Survey',
						text: 'Explore and outline your options with an in-person visit or remote video survey',
					},
					{
						icon: `
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
						</svg>
						`,
						id: 'A Preliminary Design',
						text: 'Gain insight from a renewable energy system designed specifically for you',
					},
					{
						icon: `
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
						</svg>
						`,
						id: 'An Initial Estimate',
						text: 'Give your feedback to ensure we find the right balance between cost and utility',
					}
				],
				action: {
					text: "To ensure you're passed onto the relevant team member as quickly as possible, please progress through our chatbot in the bottom right corner."
				}
			},
			relation: {
				message: `"We gave Stuart and his team a tricky brief- to install solar panels on a steep hillside behind our thatched cottage. Whereas other companies were unable to think outside standard roof installations, R-ECO came up with an ingenious augered anchor system supporting variable height stanchions. They carried out the work efficiently and enthusiastically and we are very pleased with the results."`,
				person: 'Nick & Mary Harrison',
				project: 'Ground Mounted Solar PV',
				img: {
					src: 'assets/modified/relation.jpg',
					alt: 'Solar PV Domestic Installation'
				}
			},
			utility: {
				meta: 'Services',
				title: "We're with you, every step of the way",
				content: {
					lead: "As a workers' co-operative, every member of our team has a stake in the business. Whether it's on call with one of our technicians, a collaborative effort towards a complex project design, or seeing our directors' climb a scaffold to mount your solar panels; with R-ECO you know we're in this together",
					aux: {
						title: 'The R-ECO way',
						text: "Maintaining cooperative values in a very competitive industry requires a unique approach to business. Our service is grounded in the following principles:"
					},
					list: [
						{
							value: "Responsible",
							text: "We're putting in the work to ensure our business operations have a net-positive impact on humanity and the Earth beyond the superficial."
						},
						{
							value: "Effective",
							text: "We focus on finding appropriate and practical solutions to fit your requirements and budget, whilst making our process as accessible as you desire."
						},
						{
							value: "Competent",
							text: "In a constantly changing industry, our team members continue to develop and test our technical capabilities in order to stay ahead of the curve."
						},
						{
							value: "Organised",
							text: "We've designed our workflow to limit excessive bureaucracy, unwarranted disruption, and unnecessary delays; resulting in a smooth process from start to finish."
						}
					],
					link: 'For non-residential enquiries, please visit our'
				},
				img: {
					src: '',
					alt: 'Solar PV Domestic Installation'
				},
				list: [
					{
						title: 'Design & Consultation',
						text: "Our consultation process is purposefully designed to determine whether an investment in renewable technologies is right for you. If not, we'll be honest, and advise appropriate actions for your situation.",
						icon: `
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
						</svg>
						`
					},
					{
						title: 'System Installation',
						text: "Our team has over 40 years of combined practical experience within the energy industry and is skilled across multiple technical disciplines. We leverage an extensive repertoire in every project ensuring top-quality is achieved each time we go to work.",
						icon: `
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
						</svg>
						`
					},
					{
						title: 'Maintainance & Repair',
						text: "As with everything in life - complex technologies are no different - the risk and reward come hand-in-hand. If, and when, things get complicated, you can rest assured we'll be here to provide assistance and support.",
						icon: `
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
						</svg>
						`
					}
				]
			},
			scope: {
				meta: 'Technology',
				title: 'To harness the elements',
				text: "Renewable resources provide a reliable and sustainable supply of energy, and there's a multitude of technologies available",
				options: [
					{
						img: {
							src: "assets/modified/scope/new/resized/ashp.png",
							alt: 'Air Source Heat Pump'
						},
						title: "Air Source Heat Pumps",
						hub: {
							active: false,
							link: "/tech/ashp",
							key: "Learn more"
						},
						ghg: true,
						rhi: true,
						text: "Utilise a full central heating solution to provide air conditioning, radiator and underfloor heating, and/or a hot water supply, by transferring air in and out of a building."
					},
					{
						img: {
							src: "assets/modified/scope/new/resized/powerwall.png",
							alt: 'Battery Storage'
						},
						title: "Battery Storage",
						hub: {
							active: true,
							link: "/powerwall",
							key: "Certified Tesla Powerwall Installer"
						},
						ghg: false,
						rhi: false,
						text: "Store electricity to power your home at night or during an outage; and/or take advantage of Smart Metering and Time of Use Tariffs to maximise your hour-by-hour energy usage.",
						link: "/battery-storage"
					},
					{
						img: {
							src: "assets/modified/scope/new/resized/biomass-boiler.png",
							alt: 'Biomass Boilers'
						},
						title: "Biomass Boilers",
						hub: {
							active: false,
							link: "/tech/biomass",
							key: "Learn more"
						},
						ghg: true,
						rhi: true,
						text: "Utilise a full central heating and hot water solution for your entire home by burning wood chips, pellets, and/or logs in a carbon neutral biomass boiler.",
						link: "/biomass-boilers"
					},
					{
						img: {
							src: "assets/modified/scope/new/resized/home-charger.png",
							alt: 'EV Charging'
						},
						title: "EV Charging",
						hub: {
							active: false,
							link: "/tech/charging",
							key: "Learn more"
						},
						ghg: false,
						rhi: false,
						text: "Charge your electric vehicle at the convenience of your own home to take advantage of solar energy, a Time of Use Tariff, or stable residential electricity rates.",
						link: "/ev-charging"
					},
					{
						img: {
							src: "assets/modified/scope/new/resized/solar-panel.png",
							alt: 'Solar PV'
						},
						title: "Solar PV",
						hub: {
							active: false,
							link: "/tech/solar/pv",
							key: "Learn more"
						},
						ghg: false,
						rhi: false,
						text: "Generate solar energy to power your home, store electricity in a battery for later use, or sell back to the grid with the Smart Export Guarantee scheme.",
						link: "/solar-pv"
					},
					{
						img: {
							src: "assets/modified/scope/new/resized/solar-thermal.png",
							alt: 'Solar Thermal'
						},
						title: "Solar Thermal",
						hub: {
							active: false,
							link: "/tech/solar/thermal",
							key: "Learn more"
						},
						ghg: true,
						rhi: true,
						text: "Collect sunlight to heat the air and/or water in your home, store thermal energy for later use, or convert it to electricity to power your appliances.",
						link: "/solar-thermal"
					}
				]
	
			},
			presence: {
				meta: 'About Us',
				title: 'R-ECO is at the heart of the renewable energy transition',
				content: {
					lead: 'Founded in 2006, The Renewable Energy Co-operative has 15 years experience blending enthusiasm for technological innovation and practicality with cooperative values and a long-term, purpose-driven perspective towards effective energy solutions.',
					text: [
						"As an employee-owned business at the cutting-edge of an expansive industry, our people are acknowledged as our greatest and foremost asset; investment in one future benefits our shared future.",
						"The complementary, and diverse, nature of the attitudes, competencies, and skills present within our team provides a bedrock upon which our common values and collective purpose are cultivated.",
						"This commitment to shared prosperity is the driving force behind our steadfast work ethic and deep-rooted dedication to delivering the highest standards.",
						'These values are embodied within every member of our organisation; people who are living and working with purpose naturally lead humanity to a more prosperous world for all.'
					],
					aux: "At R-ECO, we're in this together",
					vision: "By embracing the elements today, we're contributing towards a thriving world where energy sovereignty is ubiquitous; healthy, natural environments are abundant; and meaningful opportunity is open to all individuals and communities for generations to come.",
					header: "Partners & Associations",
					logos: [
						{
							src: "assets/logos/marks/mods/mcs.png",
							alt: "MCS Certified"
						},
						{
							src: "assets/logos/marks/mods/coop.png",
							alt: "Co-Operatives UK"
						},
						{
							src: "assets/logos/marks/mods/recc.png",
							alt: "Renewable Energy Consumer Code"
						},
						{
							src: "assets/logos/marks/mods/iwa.png",
							alt: "Independent Warranty Association"
						},
						{
							src: "assets/logos/marks/mods/elecsa.png",
							alt: "ELECSA"
						}
					]
				},
				img: {
					src: 'https://labs.pssys.dev/assets/domestic_001a.jpeg',
					alt: 'Solar PV Domestic Installation'
				}
			}
		},
		hub: {
			feature: {
				title: "Store sunlight for those rainy days",
				text: "With a TESLA Powerwall you can have a home energy storage system designed for solar self-consumption, time-of-use load shifting, backup power, and off-the-grid use.",
				img: {
					src: 'assets/modified/hub/battery/powerwall/Tesla.jpg',
					alt: 'Solar PV Domestic Installation'
				}
			},
			summary: {
				meta: 'Summary',
				title: "TESLA Powerwall",
				content: {
					lead: "An easy-to-install battery system designed to maximise your residential energy independence; in reality this can mean backup power and a reduced carbon footprint for your home, and/or savings on your electricity bill.",
					list: [
						{
							title: 'Functionality',
							text: "Each Powerwall system includes at least one rechargeable lithium-ion battery pack and a Backup Gateway, providing energy monitoring, metering, and management. "
						},
						{
							title: 'Performance',
							text: "Its compact, minimalist design achieves market-leading energy density and is capable of providing up to 13.5kWh of usable energy storage and 5kW of continuous power."
						},
						{
							title: 'Integration',
							text: "With a simple electrical connection to any home or building, a Powerwall can be combined with and charged from a new or existing solar system, the electricity grid, or other renewable energy sources."
						}
					]
				},
				aux: {
					title: 'Technical Specs'
				},
				list: [
					[
						{
							header: "Energy Capacity",
							info: [
								"13.5 kWh",
								"100% depth of discharge",
								"90% round trip efficiency"
							]
						},
						{
							header: "Power",
							info: [
								"7kW peak / 5kW continuous",
								"Seamless backup transition",
								"Pure sine wave output"
							]
						},
						{
							header: "Size & Weight",
							info: [
								"115cm (L) x 75.3cm (W) x 14.7cm (D)",
								"114kg"
							]
						}
					],
					[
						{
							header: "Installation",
							info: [
								"Floor or wall mounted",
								"Indoor or outdoor",
								"Up to 10 powerwalls",
								"-20°C to 50°C",
								"Water and dust resistance to IP67"
							]
						},
						{
							header: "Certifications",
							info: [
								"Meets US and international safety standards",
								"Meets US and international EMI standards"
							]
						},
						{
							header: "Warranty",
							info: [
								"10 years"
							]
						}
					]
				],
				img: {
					src: 'assets/modified/hub/battery/powerwall/Powerwall.jpg',
					alt: 'TESLA Powerwall home battery & energy storage system'
				}
			}
		}
	}
});

export default app;